"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

var _Utils = require("../../Utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var HeaderBase = _styledComponents["default"].header.withConfig({
  displayName: "Billboard__HeaderBase",
  componentId: "sc-11ndlrd-0"
})(["background-color:#222;box-sizing:border-box;color:#fff;display:block;height:100%;padding:15vh 0;position:relative;width:100%;"]);

var getCount = function getCount() {
  if (window.innerWidth < 768) return 1;
  if (window.innerWidth < 1170) return 3;
  return 5;
};

var Header = function Header(_ref) {
  var children = _ref.children,
      title = _ref.title,
      subtitle = _ref.subtitle,
      rest = _objectWithoutProperties(_ref, ["children", "title", "subtitle"]);

  var _React$useState = _react["default"].useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      count = _React$useState2[0],
      setCount = _React$useState2[1];

  _react["default"].useEffect(function () {
    var changeCount = function changeCount() {
      setCount(getCount());
    };

    changeCount();
    window.addEventListener('resize', changeCount);
  }, []);

  return /*#__PURE__*/_react["default"].createElement(HeaderBase, null, /*#__PURE__*/_react["default"].createElement(_Utils.BackgroundCoverImage, rest), /*#__PURE__*/_react["default"].createElement(_Utils.VerticalLines, {
    backgroundColor: "#FFF",
    count: count
  }), /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    maxWidth: "md",
    style: {
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    position: "relative",
    textAlign: "center",
    maxWidth: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_Utils.Headline, null, title), /*#__PURE__*/_react["default"].createElement(_Utils.Tagline, null, subtitle), children)));
};

Header.propTypes = {
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  children: _propTypes["default"].node
};
Header.defaultProps = {
  subtitle: '',
  children: null
};
var _default = Header;
exports["default"] = _default;